import { useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as ProviderSelectors from 'redux/selectors/providers'
import { getPrintableFullName } from 'util/member'
import { getAvatarUrl, getProviderInitials } from 'util/provider'
import { getProviderNameAndCredentials } from 'redux/selectors/providers'
import { fetchProviderIfNeeded } from 'redux/thunks/providers'
import { useProviderFullNameAndDetails } from './useProviderFullNameAndDetails'

export default (providerId: string, isSuccess = false) => {
  const dispatch = useDispatch()
  const provider = useSelector(ProviderSelectors.getProvider(providerId))
  const providerNameAndCreds = useSelector(getProviderNameAndCredentials(providerId))
  const providerLoading = useSelector(ProviderSelectors.isProviderFetching(providerId))

  useEffect(() => {
    if (providerId && !provider && !providerLoading) {
      try {
        // fetch providers we don't have in the store for these 'new' schedulings
        dispatch(fetchProviderIfNeeded(providerId))
      } catch (e) {
        console.error(e)
      }
    }
  }, [providerId, provider, providerLoading, dispatch])

  const { fullNameAndCredentials, details } = useProviderFullNameAndDetails(provider, isSuccess)

  const providerFullName = useMemo(() => {
    if (!provider) return ''
    return getPrintableFullName(provider)
  }, [provider])

  const providerSpecialty = useMemo(() => {
    if (!provider) return ''
    return provider.specialty
  }, [provider])

  const providerAvatarUrl = useMemo(() => {
    return getAvatarUrl(provider)
  }, [provider])

  const providerInitials = useMemo(() => getProviderInitials(provider), [provider])

  return {
    provider,
    providerLoading,
    providerFullName,
    providerSpecialty,
    providerAvatarUrl,
    providerNameAndCreds,
    providerFullNameAndCredentials: fullNameAndCredentials,
    providerDetailsString: details,
    providerInitials,
  }
}
